import { PortalSolidColor } from '@nx-frontend/shared/types/portal-colors';

interface getColorTextProps {
  color: PortalSolidColor;
  prefix?: string;
}

export const getColorTextClassNames = ({ color, prefix = '' }: getColorTextProps): string[] => {
  return [`${prefix}text-${color[0]}`];
};
